import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {autoOpen: Boolean, dismissUrl: String, clickUrl: String}

  connect() {
    this.clicked = false
    const $modal = this.jqueryModal
    if (!$modal) return

    this.onHide = this.onHide.bind(this)
    $modal.on("hide.bs.modal", this.onHide)

    if (this.autoOpenValue) {
      $modal.modal("show")
    }
  }

  disconnect() {
    const $modal = this.jqueryModal
    if ($modal && this.onHide) {
      $modal.off("hide.bs.modal", this.onHide)
    }
  }

  start() {
    this.clicked = true
    this.recordState(this.clickUrlValue)
    const $modal = this.jqueryModal
    if ($modal) $modal.modal("hide")
  }

  onHide() {
    if (this.clicked) return
    this.recordState(this.dismissUrlValue)
  }

  recordState(url) {
    if (!url) return
    fetch(url, {
      method: "POST",
      headers: {"X-CSRF-Token": this.csrfToken},
      credentials: "same-origin",
    }).catch(() => {})
  }

  get csrfToken() {
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.getAttribute("content") : ""
  }

  get jqueryModal() {
    const jq = window.jQuery
    return jq ? jq(this.element) : null
  }
}
